module.exports = __webpack_public_path__ + "img/loterialockup.199ba2f1.png";